import Vue from 'vue';
import * as C from '../constants';

export default {

  /**
   * Sets session info in state.
   *
   * @param state
   * @param payload
   */
  [C.APP_SESSION_INFO_SET](state, { user, brands, products, suppliers }) {
    Vue.set(state, 'auth', {
      ...state.auth,
      user,
      brands,
      products,
      suppliers,
      session: true,
    });
  },

  /**
   * @param state
   * @param text
   * @param color
   */
  [C.APP_SNACKBAR_SHOW](state, { text, color }) {
    state.snackbar = {
      text,
      color,
      show: state.snackbar.show + 1,
    };
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/app/mutations.js